export const resolveSignatureSupport = ({
  isSafe,
  isTempoWallet,
  allowSignatureRequirements,
  isByteCodeResolved,
  isContract
}: {
  isSafe: boolean
  isTempoWallet: boolean
  allowSignatureRequirements: boolean
  isByteCodeResolved: boolean
  isContract: boolean
}): boolean =>
  !isSafe && !isTempoWallet && allowSignatureRequirements && isByteCodeResolved && !isContract
